module.exports = __webpack_public_path__ + "img/1479916912.d51af43d.jpg";